import { memo } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import {
  Facebook, Pinterest, LinkedIn, Instagram, YouTube, Language,
  Email,
} from '@material-ui/icons';
import clsx from 'clsx';
import MarkdownToHtml from '../MarkdownToHtml';
import NavbarMenu from '../Header/Navbar/NavbarMenu';

const socialMediaIconStyles = {
  padding: '1rem',
  height: '4rem',
  width: '4rem',
  border: '2px solid var(--footerTextColorHex)',
  borderRadius: '9999px',
};

const socialMediaIconStylesWithoutBorder = {
  height: '3rem',
  width: '3rem',
};

const Footer = ({ doShowFooter, bgColorClass, textColorClass }) => {
  const { travelAgency } = useSelector((state) => state.user);
  const footerStandardVerbiage = travelAgency && travelAgency.settings
    && travelAgency.settings.footerStandardVerbiage;
  const footerImage = travelAgency && travelAgency.settings
      && travelAgency.settings.footerImage;
  const doShowFooterOnEachPages = travelAgency && travelAgency.settings
    && travelAgency.settings.doShowFooterOnEachPages;
  const affiliateTextLine = travelAgency && travelAgency.settings
    && travelAgency.settings.affiliateText;
  const doShowAffiliateTextToFooter = travelAgency && travelAgency.settings
    && travelAgency.settings.doShowAffiliateTextToFooter;
  const doRemoveFooterIconsOutline = travelAgency && travelAgency.siteTheme
    && travelAgency.siteTheme.doRemoveFooterIconsOutline;
  const doMoveHeaderLinksToFooter = travelAgency && travelAgency.siteTheme
    && travelAgency.siteTheme.doMoveHeaderLinksToFooter;
  const iconStyle = doRemoveFooterIconsOutline
    ? socialMediaIconStylesWithoutBorder : socialMediaIconStyles;
  const copyRightText = travelAgency && travelAgency.settings
  && travelAgency.settings.copyRightText;
  const displayFooterImageAtFooterTop = travelAgency && travelAgency.settings
    && travelAgency.settings.displayFooterImageAtFooterTop;
  return (
    doShowFooterOnEachPages || doShowFooter
      ? (
        <div className={clsx('font-body min-h-32', bgColorClass, textColorClass, { 'mt-24': !doShowFooter })}>
          <div className="container mx-auto px-2 sm:px-0">
            {doShowAffiliateTextToFooter && affiliateTextLine && (
              <div className="text-xs font-tagline text-black text-right py-4 container mx-auto">
                <MarkdownToHtml content={affiliateTextLine} className="text-black text-xs leading-tight" />
              </div>
            )}
            <div className="text-white flex items-end text-footer-0">
              <div className="flex flex-col bottom-0 mb-8 pt-8 w-full text-center text-footer-0">
                {travelAgency && travelAgency.socialMediaPages && (
                  <div className={clsx({ 'mb-10': !doMoveHeaderLinksToFooter, 'mb-4': doMoveHeaderLinksToFooter })}>
                    {travelAgency.socialMediaPages && travelAgency.socialMediaPages.twitter && (
                      <a className="m-3 inline" href={travelAgency.socialMediaPages.twitter} target="_blank" rel="noreferrer" aria-label="Twitter">
                        <svg style={{ ...iconStyle, display: 'inline-block' }} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                          <path d="M8 2H1L9.26086 13.0145L1.44995 21.9999H4.09998L10.4883 14.651L16 22H23L14.3917 10.5223L21.8001 2H19.1501L13.1643 8.88578L8 2ZM17 20L5 4H7L19 20H17Z" fill="currentColor" />
                        </svg>
                      </a>
                    )}
                    {travelAgency.socialMediaPages && travelAgency.socialMediaPages.email && (
                      <a className="m-3 inline" href={`mailto:${travelAgency.socialMediaPages.email}`} target="_blank" rel="noreferrer">
                        <Email style={iconStyle} />
                      </a>
                    )}
                    {travelAgency.socialMediaPages && travelAgency.socialMediaPages.instagram && (
                      <a className="m-3 inline" href={travelAgency.socialMediaPages.instagram} target="_blank" rel="noreferrer">
                        <Instagram style={iconStyle} />
                      </a>
                    )}
                    {travelAgency.socialMediaPages && travelAgency.socialMediaPages.facebook && (
                      <a className="m-3 inline" href={travelAgency.socialMediaPages.facebook} target="_blank" rel="noreferrer">
                        <Facebook style={iconStyle} />
                      </a>
                    )}
                    {travelAgency.socialMediaPages && travelAgency.socialMediaPages.pinterest && (
                      <a className="m-3 inline" href={travelAgency.socialMediaPages.pinterest} target="_blank" rel="noreferrer">
                        <Pinterest style={iconStyle} />
                      </a>
                    )}
                    {travelAgency.socialMediaPages && travelAgency.socialMediaPages.linkedin && (
                      <a className="m-3 inline" href={travelAgency.socialMediaPages.linkedin} target="_blank" rel="noreferrer">
                        <LinkedIn style={iconStyle} />
                      </a>
                    )}
                    {travelAgency.socialMediaPages && travelAgency.socialMediaPages.youtube && (
                      <a className="m-3 inline" href={travelAgency.socialMediaPages.youtube} target="_blank" rel="noreferrer">
                        <YouTube style={iconStyle} />
                      </a>
                    )}
                    {travelAgency.socialMediaPages && travelAgency.socialMediaPages.threads && (
                    <a className="m-3 inline" href={travelAgency.socialMediaPages.threads} target="_blank" rel="noreferrer" aria-label="Threads">
                      <svg style={{ ...iconStyle, display: 'inline-block' }} xmlns="http://www.w3.org/2000/svg" shapeRendering="geometricPrecision" textRendering="geometricPrecision" imageRendering="optimizeQuality" fillRule="evenodd" clipRule="evenodd" viewBox="0 0 512 512">
                        <path d="M105 0h302c57.75 0 105 47.25 105 105v302c0 57.75-47.25 105-105 105H105C47.25 512 0 464.75 0 407V105C0 47.25 47.25 0 105 0z" />
                        <path fill="#fff" fillRule="nonzero" d="M337.36 243.58c-1.46-.7-2.95-1.38-4.46-2.02-2.62-48.36-29.04-76.05-73.41-76.33-25.6-.17-48.52 10.27-62.8 31.94l24.4 16.74c10.15-15.4 26.08-18.68 37.81-18.68h.4c14.61.09 25.64 4.34 32.77 12.62 5.19 6.04 8.67 14.37 10.39 24.89-12.96-2.2-26.96-2.88-41.94-2.02-42.18 2.43-69.3 27.03-67.48 61.21.92 17.35 9.56 32.26 24.32 42.01 12.48 8.24 28.56 12.27 45.26 11.35 22.07-1.2 39.37-9.62 51.45-25.01 9.17-11.69 14.97-26.84 17.53-45.92 10.51 6.34 18.3 14.69 22.61 24.73 7.31 17.06 7.74 45.1-15.14 67.96-20.04 20.03-44.14 28.69-80.55 28.96-40.4-.3-70.95-13.26-90.81-38.51-18.6-23.64-28.21-57.79-28.57-101.5.36-43.71 9.97-77.86 28.57-101.5 19.86-25.25 50.41-38.21 90.81-38.51 40.68.3 71.76 13.32 92.39 38.69 10.11 12.44 17.73 28.09 22.76 46.33l28.59-7.63c-6.09-22.45-15.67-41.8-28.72-57.85-26.44-32.53-65.1-49.19-114.92-49.54h-.2c-49.72.35-87.96 17.08-113.64 49.73-22.86 29.05-34.65 69.48-35.04 120.16v.24c.39 50.68 12.18 91.11 35.04 120.16 25.68 32.65 63.92 49.39 113.64 49.73h.2c44.2-.31 75.36-11.88 101.03-37.53 33.58-33.55 32.57-75.6 21.5-101.42-7.94-18.51-23.08-33.55-43.79-43.48zm-76.32 71.76c-18.48 1.04-37.69-7.26-38.64-25.03-.7-13.18 9.38-27.89 39.78-29.64 3.48-.2 6.9-.3 10.25-.3 11.04 0 21.37 1.07 30.76 3.13-3.5 43.74-24.04 50.84-42.15 51.84z" />
                      </svg>
                    </a>
                    )}
                    {travelAgency.socialMediaPages && travelAgency.socialMediaPages.website && (
                      <a className="m-3 inline" href={travelAgency.socialMediaPages.website} target="_blank" rel="noreferrer">
                        <Language style={iconStyle} />
                      </a>
                    )}
                  </div>
                )}
                {doMoveHeaderLinksToFooter && <NavbarMenu navbar={false} />}
                <div className="inline-flex justify-center gap-4 mb-2">
                  {travelAgency && travelAgency.termsOfUsePageUrl && (
                  <a href={travelAgency.termsOfUsePageUrl} target="_blank" className="text-s" rel="noreferrer">
                    Terms of Service
                  </a>
                  )}
                  {travelAgency && (
                  <a href={travelAgency.privacyPageUrl ? travelAgency.privacyPageUrl : `/${travelAgency.agencyAliasName}/privacyPolicy`} target="_blank" rel="noreferrer">
                    Privacy Center
                  </a>
                  )}
                </div>
                <div>
                  ©
                  {' '}
                  {new Date().getFullYear()}
                  {' '}
                  {copyRightText || (
                    travelAgency && travelAgency.name ? travelAgency.name : 'TravelWits LLC'
                  )}

                </div>
                {footerStandardVerbiage && (
                  <div className="mt-2 inline-flex justify-center">
                    <MarkdownToHtml content={footerStandardVerbiage} className="text-footer-0 text-xs font-normal" />
                  </div>
                )}
                {footerImage && (
                  <div className={clsx('text-center', { 'mt-0 mb-8 order-first': displayFooterImageAtFooterTop, 'mt-8': !displayFooterImageAtFooterTop })}>
                    <img src={footerImage} alt="Footer" className="w-full lg:w-2/3 inline-block" />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )
      : <></>

  );
};
Footer.propTypes = {
  doShowFooter: PropTypes.bool,
  bgColorClass: PropTypes.string,
  textColorClass: PropTypes.string,
};

Footer.defaultProps = {
  doShowFooter: false,
  bgColorClass: 'bg-footer-0',
  textColorClass: 'text-footer-0',
};
export default memo(Footer);
